import { SET_LOAD, CLOSE_LOAD } from "./type";

export const setLoad = ({ show, loadMessage, progress }) => ({
  type: SET_LOAD,
  payload: { show, loadMessage, progress }
});

export const closeLoad = () => ({ type: CLOSE_LOAD, payload: {} });
